export default __webpack_public_path__ + "static/media/lens_active.dbc8cbf7.svg";